export async function getRestrictedArticles(
  locationId: number,
): Promise<any> {
  const data = await api.ibexaApi.get(`/tos/${locationId}`)
  return data.data.locations
}
